var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.42,
    height: 17.314,
    viewBox: "0 0 16.42 17.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8645",
    "data-name": "Group 8645",
    transform: "translate(0.505 0.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17639",
    "data-name": "Path 17639",
    d: "M1.024-10.339q.227.014.47.014a3.118,3.118,0,0,0,.477-.036,2.141,2.141,0,0,0,.446-.118,1.3,1.3,0,0,0,.381-.227,1.134,1.134,0,0,0,.277-.364,1.5,1.5,0,0,0,.137-.528H.816a1.593,1.593,0,0,1,.08-.142l.137-.229q.087-.14.193-.3H3.092a.375.375,0,0,0-.121-.253,1.324,1.324,0,0,0-.292-.229,2.1,2.1,0,0,0-.349-.166.9.9,0,0,0-.294-.065H.816A1.132,1.132,0,0,1,.9-13.159q.065-.116.137-.229l.128-.2a.548.548,0,0,1,.06-.087H5.242l-.027.053q-.027.053-.07.128l-.1.164-.1.166-.077.128-.031.051H3.786a3.094,3.094,0,0,1,.176.349,1.253,1.253,0,0,1,.094.364H5.242l-.4.675H4.1a1.919,1.919,0,0,1-.253.766,1.863,1.863,0,0,1-.477.528,2.179,2.179,0,0,1-.629.323,3.694,3.694,0,0,1-.713.157.119.119,0,0,0,.017.031q.017.027.041.06a.985.985,0,0,0,.058.082l2.14,2.955v.121H3.366L1.024-9.7Z",
    transform: "translate(5.072 18.419)",
    fill: "#091b49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17640",
    "data-name": "Path 17640",
    d: "M16.4,9.737A7.737,7.737,0,0,0,1.534,5.914M1.05,2.045V5.914H4.919",
    transform: "translate(-1.05 -1.04)",
    fill: "none",
    stroke: "#091b49",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18360",
    "data-name": "Path 18360",
    d: "M15.349,8.7A7.737,7.737,0,0,0,.484,4.874M0,1.006V4.874H3.869",
    transform: "translate(15.41 16.284) rotate(180)",
    fill: "none",
    stroke: "#091b49",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.708d9c5bc7ca72c63d7dab497f51677a.svg";
export { ForwardRef as ReactComponent };